import { useBiLogger } from '../../Provider/BiLogger/BiLoggerProvider';
import { amountToLong } from '../../../utils/amountToLong';
import { selectHighestSupportedApplePayVersion, selectTopProps } from '../../../selectors';
import { useSelector } from '../../../store';
import { selectAvailableFundingSourcesMetadata } from '../../../selectors/domain';
import { expressCheckoutWidgetLoadingFinished } from '../../../utils/bi/events/expressCheckoutWidgetLoadingFinished';
import { expressCheckoutMorePaymentOptionsButtonClicked } from '../../../utils/bi/events/expressCheckoutMorePaymentOptionsButtonClicked';

export const useBI = () => {
  const biLogger = useBiLogger();
  const { currency, paymentAmount, meta } = useSelector(selectTopProps);
  const applePayVersion = useSelector(selectHighestSupportedApplePayVersion);
  const availableMethodsFundingSourcesMetadata = useSelector(selectAvailableFundingSourcesMetadata);
  const commonBiParams = {
    currency,
    appInstanceId: meta.appInstanceId,
    origin: meta.productId ? 'product' : 'cart',
    productId: meta.productId,
    amount: amountToLong(paymentAmount),
    orderSnapshotId: undefined as any, // TODO[bi]
    transactionId: undefined as any, // TODO[bi]
    isPartner: undefined as any, // TODO[bi]
    shippingAmount: undefined as any, // TODO[bi]
    taxAmount: undefined as any, // TODO[bi]
    discountAmount: undefined as any, // TODO[bi]
    cartId: undefined as any, // TODO[bi]
    productid: undefined as any, // TODO[bi]
    orderType: undefined as any, // TODO[bi]
    result: undefined as any, // TODO[bi]
    errorReason: undefined as any, // TODO[bi]
  } as const;

  return {
    reportLoaded: () =>
      biLogger.report(expressCheckoutWidgetLoadingFinished, {
        flowType: String(applePayVersion),
        paymentmethod: availableMethodsFundingSourcesMetadata.map((method) => method.methodId).join(','),
        paymentProviderList: availableMethodsFundingSourcesMetadata
          .map((method) => `${method.methodId}:${method.providerId}`)
          .join(','),
        amount: amountToLong(paymentAmount),
        ...commonBiParams,
      }),

    reportMoreOptionsClicked: () => biLogger.report(expressCheckoutMorePaymentOptionsButtonClicked, commonBiParams),
  };
};
